import { useEffect, useState } from "react";
import { api, track } from "@/lib/api";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { AppGallery } from "@/components/AppGallery";
import { ContactSection } from "@/components/ContactSection";
import { PaymentMethods } from "@/components/PaymentMethods";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [apps, setApps] = useState([]);
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionStorage.getItem("ca_visited")) {
      sessionStorage.setItem("ca_visited", "1");
      track("visit");
    }
    api.get("/apps")
      .then(({ data }) => setApps(data))
      .catch(() => setApps([]))
      .finally(() => setLoading(false));
    api.get("/payment-methods")
      .then(({ data }) => setMethods(data))
      .catch(() => setMethods([]));
  }, []);

  return (
    <div data-testid="home-page">
      <Header />
      <Hero />
      <Marquee />
      <AppGallery apps={apps} loading={loading} />
      <ContactSection apps={apps} />
      <PaymentMethods methods={methods} />
      <Footer />
    </div>
  );
}
